function homepageScripts() {
  //for all the compound-hero__bg images
  $(".compound-hero__bg img").each(function () {
    $item = $(".compound-hero__bg img");
    $imgUrl = $item.data("src");
    $item
      .parent()
      .css("background-image", 'url("' + $imgUrl + '")')
      .addClass("loaded");
  });

  //For mp4 banner instead of static banner'
  const banner = document.getElementById("video-banner");
  const bannerHome = document.getElementById("video-banner-home");
  if (banner) {
    function setVideoBanner(data) {
      let vData;
      vData = banner.getAttribute(data);
      vData !== undefined && banner.setAttribute("src", vData);
      bannerHome.load();
    }
    $(window).width() <= 480
      ? setVideoBanner("data-mobilesource")
      : setVideoBanner("data-desktopsource");
  }
}

async function getTopPerformingFunds(fundType = "ETF", period = "yeartodate") {
  try {
    const blockID = $("#topPerformanceFunds").attr("data-blockid") ?? 0;
    const language = $("#topPerformanceFunds").attr("data-language") ?? "en";
    const country = $("#topPerformanceFunds").attr("data-country");

    if (!blockID) {
      console.error("Block ID is missing");
      return;
    }

    const url = new URL(
      "/Main/TopPerformanceFundsBlock/GetTopPerformanceFunds",
      window.location.href
    );
    url.searchParams.set("blockid", blockID);
    url.searchParams.set("fundtype", fundType);
    url.searchParams.set("period", period);
    url.searchParams.set("country", country);
    url.searchParams.set("language", language);

    const response = await fetch(url);
    if (!response.ok) {
      console.error("Network response was not OK");
      return;
    }
    const result = await response.json();
    return result;
  } catch (err) {
    console.error("There has been a problem with fetching funds:", err);
    return;
  }
}

function updateTopPerformingFundList(fundList = null) {
  if (!fundList) return;

  if (fundList.Performances.length < 1) {
    const emptyFundsMessage = `<div>No Funds matching the selected criteria, please change filters.</div>`;
    $("#topPerformanceFunds .data-display-section").append(
      emptyFundsMessage.trim()
    );
    $("#topPerformanceFunds .as-of-date").addClass("d-none");
    $("#topPerformanceFunds .chart-disclaimer").addClass("d-none");
    return;
  }

  fundList.Performances.forEach((fund, i) => {
    const fundElement = `<div class="fund-item">
      <a
        class="cta-link fundlist-block__cta-item d-flex justify-content-between align-items-center fund-row-block__link"
        href="${fund.Url}"
      >
        <div class="fund-info">
          <span class="fund-ticker">${fund.Ticker}</span>
          <span class="fund-name">${fund.FundName}</span>
        </div>

        <span class="fund-performance">${fund.FormattedValue}%</span>
      </a>
    </div>`;

    $("#topPerformanceFunds .data-display-section").append(fundElement.trim());

    $("#topPerformanceFunds .as-of-date span").text(fundList.AsOfDateText);
    $("#topPerformanceFunds .as-of-date").removeClass("d-none");

    $("#topPerformanceFunds .chart-disclaimer").removeClass("d-none");
  });
}

function topPerformningFunds() {
  const topPerformanceFunds = $("#topPerformanceFunds");
  if (!topPerformanceFunds.length) return;

  topPerformanceFunds.find(".data-display-section .fund-section")?.hide();
  const periodButton = topPerformanceFunds.find(".performance-periods button");
  const sixMonthsPeriodBtn =  topPerformanceFunds.find(".performance-periods button[value='SixMonth']");
  sixMonthsPeriodBtn.remove();

  async function getPerformersByPeriod() {
    const selectedPeriod = $(this).val().trim();
    let fundTypeElement = topPerformanceFunds.find(
      ".fund-type-dropdown button.fund-type-button:first"
    );
    if (fundTypeElement.length == 0) {
      fundTypeElement = topPerformanceFunds.find("span.fund_type_label:first");
    }
    const selectedFundType = fundTypeElement?.attr("data-selected-val");

    topPerformanceFunds
      .find(".period-dropdown button.period-button:first")
      ?.data("selected-val", selectedPeriod)
      ?.attr("data-selected-val", selectedPeriod);

    topPerformanceFunds.find(".period_label")?.text($(this).text());

    topPerformanceFunds.find(".data-display-section")?.empty();

    const fundList = await getTopPerformingFunds(
      selectedFundType,
      selectedPeriod
    );
    updateTopPerformingFundList(fundList);
  }

  periodButton?.on("click", getPerformersByPeriod);
}

window.addEventListener("DOMContentLoaded", homepageScripts);
window.addEventListener("DOMContentLoaded", topPerformningFunds);
